<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid mt-3 p-0">
    <div class="form-group">
      <div class="row">
        <div class="col-lg-12 mb-2">
          <h1>Congratulations! your list is saved</h1>
          How do you want to share your list?
        </div>
      </div>
      <!--
  <div class="row mt-3">
    <div class="col-12">
      {{ $t('sharing_options') }}:
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-12">
      <select class="form-control" v-model="selectedAuth" @change="changedAuth" v-bind:id="'select_authtype_' +  getId()">
        <option value="authentication" style="">{{ $t('authentication_require') }}</option>
        <option value="onlyemail" style="">{{ $t('simple_email') }}</option>
        <option value="anonymous" style="">{{ $t('anonymous') }}</option>
      </select>
    </div>
  </div>
    -->
      <div class="row mt-1 d-md-none" v-if="hidemdnbutton == false">
        <div class="col-12 text-center">
          <button @click="mdnAssignUrl" v-bind:id="'mdnButton_' + getId()" type="button" class="btn skin primary-button col-12"><i class="icon-link mt-0 mr-1"></i>Share</button>
        </div>
      </div>
      
  <div class="row mt-1">
    <div class="col-12 text-center">
      <button v-bind:id="'copyButton_' + getId()" type="button" class="btn skin primary-button col-12"><i class="icon-link mt-0 mr-1"></i>Copy link to list</button>
    </div>
  </div>
      <div class="row mt-1" v-if="copyError == true">
        <div class="col-12 text-center">
          Could not copy url, please copy it manually<br />
          http://iprocedo.com/{{getAssignUrl()}}
        </div>
      </div>

      <div class="row mt-0" v-if="confirmCopy == true">
        <div class="col-12 text-center">
          <label class="custom-form-label">{{$t('copied_to_clipboard')}}</label>
        </div>
      </div>
      <div class="row mt-1" v-if="qrcodevisible == false">
        <div class="col-12 text-center">
          <button class="btn skin primary-button col-12" @click="showQRCode"><i class="icon-qrcode mt-0 mr-1"></i>Create QR code for list</button>
        </div>
      </div>
      <div class="row mt-1" v-show="qrcodevisible == true">
        <div class="col-12 text-center">
          <img width="100" @click="printImage" height="100" v-bind:src="qrsource" />
        </div>
        <div v-show="false">{{ qrcodeurl }}</div>
      </div>

      <div class="row mt-3" v-show="qrcodevisible == true">
        <div class="col-12 text-center">
          <button class="btn skin primary-button" @click="printImage">{{$t('print_qr_code_button_text')}}</button>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12 text-center">
          <button class="btn skin primary-button col-12" @click="showEmailOrSms"><i class="icon-envelop2 mt-0 mr-1"></i>Send list by Email</button>
        </div>
      </div>
      <div class="col-12 p-0" v-show="shareemailorsms == true">
        <form id="shareEmailSmsForm" name="shareEmailSmsForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-1">
            <div class="col-12 text-center">
              <input type="text" v-model="sendORSms" required v-bind:id="'txt_emailsms_' +  getId()" v-bind:placeholder="'Email'" class="form-control" style="display:inline;" />
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12 text-center">
              <button @click="sendEmailForUrl" v-bind:id="'shareemailorsmsButton_' + getId()" type="submit" class="btn skin primary-button col-12">{{$t('send')}}</button>
            </div>
          </div>
          <div class="row mt-0">
            <div class="col-12 text-center">
              <label class="custom-form-label">{{msgSmsOrEmail}}</label>
            </div>
          </div>
        </form>
      </div>

      <div class="col-12 p-0">
        <button @click="backclick" type="button" class="btn mt-2"
                style="float: left; background-color: #e3e3e3">
          back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'share-task-list',
    components: {
    },
    data() {
      return {
        categoryId: 0,
        categoryname: '',
        username: '',
        selectedAuth: 'onlyemail',
        qrcodevisible: false,
        shareemailorsms: false,
        copyError: false,
        confirmCopy: false,
        qrcodeurl: '',
        sendORSms: '',
        msgSmsOrEmail: '',
        copyUrl: '',
        hidemdnbutton: false,
      }
    },
    props: {
      //categoryId: {
      //  type: Number,
      //  default: 0
      //},
      //username: {
      //  type: String,
      //  default: ""
      //},
      //categoryname: {
      //  type: String,
      //  default: ""
      //},
    },
    methods: {
      backclick() {
        this.$parent.setSectonShow('savelist');
      },
      setData(catid, user, catname) {
        this.categoryId = catid;
        this.categoryname = catname;

      },
      sendEmailForUrl() {
        try {
          if (ValidateEmail(this.sendORSms) === false && isNaN(this.sendORSms)) {
            this.msgSmsOrEmail = this.$t('enter_email_or_sms');
            return false;
          }
          var url = this.getUrl('SendEmailShareTaskList') + '&emailorsms=' + this.sendORSms;
          this.$http.get(url).then(response => {
            //this.qrcodeurl = response.data.Url;
            if (response.data.Error != null && response.data.Error != "") {
              this.msgSmsOrEmail = response.data.Error;
            }
            else
              this.msgSmsOrEmail = this.$t('email_or_sms_sent');
            this.sendORSms = '';
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getUrl(methodname) {
        var url = '/api/microservice/' + methodname + '?categoryid=' + this.categoryId + '&authType=' + this.selectedAuth;
        return url;
      },
      showEmailOrSms() {
        this.qrcodevisible = false;
        this.shareemailorsms = !this.shareemailorsms;
      },
      showQRCode() {
        this.shareemailorsms = false;
        this.qrcodevisible = !this.qrcodevisible;
        if (this.qrcodevisible == true)
          this.getQRCodeUrl();
      },
      changedAuth() {
        this.getQRCodeUrl();
        this.$forceUpdate();
      },
      getQRCodeUrl() {
        try {
          var url = this.getUrl('GetQRCodeUrl');
          this.$http.get(url).then(response => {
            this.qrcodeurl = response.data.Url;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getId() {
        return this._uid;
      },

      printImage(src) {
        var procedureName = this.categoryname;
        if (procedureName == null || procedureName == "" || typeof (procedureName) == "undefined")
          procedureName = this.$t('scan_this_qrcode_title');
        var description = "";//  this.$t('scan_this_qrcode_description');
        var win = window.open('about:blank', "_new");
        win.document.open();
        //'   <body onload="window.print()" onafterprint="window.close()">',
        win.document.write([
          '<html>',
          '   <head>',
          '   <link href="/assets/css/all.css" rel="stylesheet" type="text/css">',
          '   </head>',
          '   <body>',
          '   <div class="container-fluid" style="max-width:270px">',
          '   <div class="row col-12">',
          '   <div class="card">',
          '       <h1 contenteditable="true" class="pt-3 pb-3 mb-0 text-center">' + procedureName + '</h1><div style="background-color:white;padding:0px;padding-top:0px;text-align:center"><img width="190" height="190" src="' + this.qrsource + '"/></div>',
          '       <div class="card-body" contenteditable="true">Scan the code, login and update your task!</div>',
          '   </div>',
          '   </div>',
          '   </div>',
          '   </body>',
          '</html>'
        ].join(''));
        win.document.close();
      },
      mdnAssignUrl() {
        var thisContex = this;
        try {
          var url = '/api/microservice/GetLinkCode?categoryid=' + this.categoryId + '&authType=' + this.selectedAuth;
          this.$http.get(url).then(response => {
            this.copyUrl = response.data.Url;
            let shareData = {
              title: response.data.categoryname,
              text: response.data.categoryname,
              url: response.data.Url,//'https://iprocedo.com/home/no/assign?enc=d7b69844-4802-ef11-aef1-6045bdaceadc',//'https://developer.mozilla.org',
            }
            navigator.share(shareData)
              .then(() =>
                console.log('MDN shared successfully')
              )
              .catch((e) => {
                alert(JSON.stringify(e));
                //thisContex.copyError = true
              }
               
              )
            //try {
            //  this.copy(response.data.Url);
            //  thisContex.confirmCopy = true;
            //}
            //catch (e) {
            //  console.error(e);
            //  this.copyError = true;
            //}
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getAssignUrl() {
        var url = '/api/microservice/GetLinkCode?categoryid=' + this.categoryId + '&authType=' + this.selectedAuth;
        return url;
      },
       copyAssignUrl() {
        var thisContex = this;
        try {
          var url = '/api/microservice/GetLinkCode?categoryid=' + this.categoryId + '&authType=' + this.selectedAuth;
          this.$http.get(url).then(async response => {

            this.copyUrl = response.data.Url;

            try {
              let result = await thisContex.copy(response.data.Url);
              thisContex.confirmCopy = true;
            }
            catch (e) {
              console.error(e);
              this.copyError = true;
            }
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async copy(text) {
        //https://stackoverflow.com/questions/69438702/why-does-navigator-clipboard-writetext-not-copy-text-to-clipboard-if-it-is-pro
        return new Promise(async (resolve, reject) => {

          if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
              document.execCommand("copy");
              document.body.removeChild(textarea);
              resolve();
            }
            catch (e) {
              document.body.removeChild(textarea);
              reject(e);
            }
          }
          else if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && typeof ClipboardItem !== "undefined") {
            const type = "text/plain";
            const blob = new Blob([text], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            try {
              let result = await navigator.clipboard.write(data);
            }
            catch (error) {

              reject(new Error("Permission not granted!"));
            }
          }
          else {
            reject(new Error("None of copying methods are supported by this browser!"));
          }
        });
      },

    },
    created() {

    },

    mounted() {
      //_componentValidation('#shareEmailSmsForm');

      var buttonId = '#copyButton_' + this.getId();
      var thisContext = this;
      $(buttonId).on("click", function () {
        thisContext.copyAssignUrl();
      });

      //var buttonId = '#copyButton_' + this.getId();
      //var thisContext = this;
      //$(buttonId).on("click", function () {
      //  thisContext.copyAssignUrl();
      //});
      if (!navigator.canShare) {
        //alert("Your browser doesn't support the Web Share API.");
        this.hidemdnbutton = true;
      }
    },
    watch: {

    },
    computed: {
      qrsource: {
        get: function () {
          return '/api/microservice/GetQRCode?categoryid=' + this.categoryId + '&authType=' + this.selectedAuth;
        },
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/microservice/share-task-list.vue